import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import { colors } from "healthex-common/colors";
import styled from "styled-components";
import { FlexColumnDiv } from "./common.styles";
export const PreLoginPasswordContent = styled(FlexColumnDiv) `
    width: 100%;
    gap: 16px;
    align-self: stretch;
    flex-grow: 1;
`;
export const PreLoginPasswordFields = styled(FlexColumnDiv) `
    gap: 16px;
`;
export const PreLoginPasswordSuccessIcon = styled(CheckCircleOutline) `
    color: ${colors.forest_main};
    width: 36px;
    height: 36px;
`;
export const PreLoginErrorIcon = styled(ErrorOutline) `
    color: ${colors.tulip_main};
    width: 36px;
    height: 36px;
`;
export const PreLoginFormErrorMessage = styled.div `
    color: ${colors.tulip_main};
    font-size: 14px;
`;
